<template>
  <div class="support-cultural-program">
    <div class="support-cultural-program-header">
      <div class="logo"></div>
      <div class="contact" v-if="setting.supportPhone">
        <div class="contact-label">Служба поддержки</div>
        <div class="contact-number">{{ setting.supportPhone }}</div>
      </div>
    </div>

    <div class="support-cultural-program-body">
      <div class="support-cultural-program-info">
        <div class="poster-wrapper">
          <img class="poster" :src="`${setting.donationEventImage}`" alt="" />
        </div>
        <!-- {{this.movie.MovieImageUrl}} -->
        <div class="info-event--text">
          <div>
            <h1>{{ setting.donationEventTitle }}</h1>
          </div>
          <div>
            <p
              v-html="
                setting.donationEventDescr ||
                  'Мы благодарны каждому, кто поддержит кинотеатр'
              "
            ></p>
          </div>
        </div>
      </div>

      <div class="donations">
        <h2>Сумма поддержки</h2>
        <div class="step-box-inputs">
          <div class="variants-donation">
            <label
              v-for="(donationMoneySize,
              index) in setting.donationEventMoney.split(' ')"
              v-bind:key="index"
              @click="selectDonationSizes(donationMoneySize)"
            >
              {{ donationMoneySize }} {{ setting.currency }}
            </label>
          </div>
          <span class="and">или</span>
          <div class="input-wrapper">
            <input
              :value="cart.donations"
              id="donations"
              @input="onChangeInputDonationSizes"
              placeholder="Введите сумму"
              type="number"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="support-cultural-program-footer">
      <div class="basket-step-forward">
        <div class="basket-btn" @click="goNext">
          <span class="btn-icon"></span>
          <span class="btn-label">Поддержать</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { types } from '@/types';

export default {
  name: 'SupportCulturalProgram',

  data() {
    return {
      donations: '',
    };
  },

  computed: {
    ...mapState(['setting', 'user', 'movie', 'cart', 'bar']),
  },

  mounted() {
    console.log(this.setting.donationEventShow, 'false', 'true');
    // !this.setting.donationEventShow && this.$router.push('hall');
  },

  methods: {
    log(msg) {
      console.log(msg);
    },

    onChangeInputDonationSizes(e) {
      this.$store.commit(types.SET_DONATION_SIZE, e.target.value);
    },

    selectDonationSizes(donationSize) {
      this.$store.commit(types.SET_DONATION_SIZE, donationSize);
    },

    goNext() {
      this.$store.dispatch('logRoute', {
        changes: 'Переход на страницу Подтверждения заказа',
        status: 'up',
      });
      this.$router.push(
        `/${this.$route.params.theatreId}/${this.$route.params.session}/buy`,
      );
    },
  },
};
</script>

<style lang="scss">
.support-cultural-program {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;

  &-header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    color: #fff;
    padding: 0 80px;
    border-bottom: 1px solid #fff3;
    box-sizing: border-box;
    overflow: hidden;
    box-sizing: border-box;
    flex: 1 0 auto;
    position: fixed;
    width: 100%;
    height: 65px;
    top: 0;
    left: 0;
    z-index: 10;
    background: #24262ce6;

    .logo {
      display: none;
      width: 166px;
      height: 25px;
    }

    .contact {
      position: absolute;
      right: 90px;
      top: 15px;
      &-label {
        text-transform: uppercase;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 1px;
        color: #fff;
        color: #fffc;
        margin-bottom: 2px;
      }
      &-number {
        font-size: 17px;
        line-height: 20px;
        font-weight: 500;
        letter-spacing: 0.5px;
        color: #fff;
      }
    }
  }

  &-body {
    display: flex;
    flex-wrap: wrap;
    /*margin-bottom: 110px;*/
    margin-top: 75px;
    padding-bottom: 50px;
    margin-bottom: 50px;
    z-index: 5;
    flex-grow: 1;
    flex-shrink: 0;
    flex-direction: column;
    padding: 45px 50px;

    .donations {
      h2 {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
        text-align: center;
        letter-spacing: -0.02em;
        color: #ffffff;
        display: block;
        max-width: 400px;
        margin-top: 18px;
      }

      label {
        background: #ff8000;
        border-radius: 4px;
        line-height: 32px;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        text-align: center;
        letter-spacing: -0.02em;
        color: #ffffff;
        width: 70px;
        display: inline-block;
        box-sizing: border-box;
        margin: 8px 16px 8px 0;
      }

      .step-box-inputs {
        display: flex;
        align-items: center;
        margin-top: 16px;
      }

      .and {
        color: #919295;
        margin-top: 8px;
        margin-bottom: 8px;
        margin-right: 10px;
      }

      .step-box-inputs {
        .input-wrapper {
          input {
            background-color: #464646;
            border: 2px solid #919295;
            box-sizing: border-box;
            border-radius: 4px;
            padding: 6px 10px;
            font-size: 16px;
            margin-top: 8px;
            margin-bottom: 8px;
            color: #fff;
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
            &[type='number'] {
              -moz-appearance: textfield;
            }
          }
        }
      }
    }

    .step-box.donation-step {
      .input-wrapper {
        margin: 0;
      }
    }
  }

  &-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    background-color: #24262ce6;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    color: #fff;
    padding: 5px;
    border-top: 1px solid #cdcfd024;
    z-index: 30;
    font-size: 18px;
  }

  &-info {
    display: flex;
    flex-wrap: wrap;

    .poster-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-bottom: 1rem;
      padding: 0 4rem;
    }

    .poster {
      max-width: 340px;
      width: 100%;
      max-height: 280px;
      object-fit: contain;
    }

    h1 {
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 30px;
      line-height: 35px;
      display: flex;
      align-items: center;
      letter-spacing: -0.02em;
      color: #ffffff;
      margin-bottom: 50px;
    }

    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 18px;
      display: flex;
      align-items: center;
      color: #919295;
    }

    li {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 18px;
      display: flex;
      align-items: center;
      color: #919295;
      margin-left: 2rem;
    }
  }
}

.info-event--text a {
  color: #ff8000;
  opacity: 0.9;
  transition: all 0.5s;
  &:hover,
  &:active,
  &:focus {
    color: #ff8000;
    opacity: 1;
  }
}

@media only screen and (min-width: 768px) {
  .support-cultural-program {
    &-header .contact {
      display: block;
    }

    &-footer {
      padding: 20px 4% 20px;
    }

    &-info {
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
    }

    .poster-wrapper {
      width: 40%;
      padding: 0 4rem 0 0;
    }

    .info-event--text {
      width: 60%;
    }
  }

  .basket-step-forward {
    flex: 0 0 250px;
  }
  .basket-btn {
    padding: 0 32px;
  }
}

@media only screen and (min-width: 1000px) {
  .support-cultural-program {
    .poster-wrapper {
      width: 35%;
    }

    .info-event--text {
      width: 65%;
    }
  }
}
</style>
